import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Popover, OverlayTrigger, Modal, Button, ButtonToolbar, DropdownButton, MenuItem, ControlLabel, Label, InputGroup, Form, FormGroup, Row, Col, FormControl } from 'react-bootstrap'
// import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import BackupcarStore from 'stores/BackupcarStore'
import DatePicker from '../../component/element/DatePicker'
// import ConfirmPopup from '../../component/element/ConfirmPopup'
// import CKAutocomplete from '../../component/element/CKAutocomplete'
// import { Checkbox } from 'react-icheck';
// import IframeModal from '../../component/element/IframeModal'
// import Select from 'react-select'
import {connect} from 'react-redux'
import Moment from 'moment';
const NotificationSystem = require('react-notification-system');
// const DEFAULT_ROW = 10

class BackupCarRegistration extends Component {

  constructor(...args) {
    super(...args)
    this.state = this.initState()
  }

  initState(newState) {
    let state = {
      loading:false,
      data:[],
      showAdd:false,
      doc:this.getEmptyDoc(),
      validDoc:this.getEmptyValidDoc(),
      isSave:true,
      date:this.getToDay(),
      brId:null
    }
    if (newState !== undefined) {
      state = Object.assign(state, newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
    this.loadData()
  }

  loadData() {
    this.setState({loading:true})
    BackupcarStore.loadCarReservation(this.state.date,(result)=>{
      this.setState({data:result.data,loading:false})
    })
  }

  newEmptyRow(number) {
    return new Array(number).fill(null).map((item, index) => {
      return {
        brand_model: "",
        car_registration_no: "",
        ref_no: "",
        remark: "",
        used_duration: "",
        used_period: "",
        work_no: ""
      }
    })
  }

  getEmptyDoc() {
    return {backupcar_registration_id:"",ref_no:"",car_registration_no:"",brand_model:""}
  }

  getEmptyValidDoc() {
    return {ref_no:null,car_registration_no:null,brand_model:null}
  }

  getToDay() {
    return Moment().format('L').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')));
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onRowAdd(number) {
    this.setState({showAdd:true})
  }

  onDocChange(field,e) {
    let {doc} = this.state
    doc[field] = e.target.value
    this.setState({doc:doc})
  }

  onDateChange(e) {
    let {date} = this.state
    date = e
    this.setState({date:date},()=>{
      this.loadData()
    })
  }

  onAddHide() {
    this.setState({showAdd:false})
  }

  onSaveClick() {
    let {doc,validDoc} = this.state
    let {messages} = this.props
    this.setState({validDoc:this.getEmptyValidDoc(),isSave:false,loading:true},()=>{
      if (doc.ref_no==='') {
        validDoc.ref_no = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false})
        return false
      } else if (doc.brand_model==='') {
        validDoc.brand_model = 'error'
        this.setState({validDoc:validDoc,isSave:true,loading:false})
        return false
      } 
      BackupcarStore.saveCarReservation(doc,(result)=>{
        if (result.status==='OK') {
          this._notificationSystem.addNotification({
            title:messages['Notification'],
            message:messages['Save successfully'],
            level:'info',
            position:'tc'        
          });
          this.setState({showAdd:false,loading:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc()},()=>{
            this.loadData()
          })
        }
      },()=>{
        this._notificationSystem.addNotification({
          title:messages['Notification'],
          message:messages['Save failed'],
          level:'error',
          position:'tc'        
        });
        this.setState({showAdd:false,loading:false,isSave:true,doc:this.getEmptyDoc(),validDoc:this.getEmptyValidDoc()})
      })
    })
  }

  onRowSelect(item) {
    let {doc} = this.state
    doc.backupcar_registration_id = JSON.parse(JSON.stringify(item.backupcar_registration_id))
    doc.ref_no = JSON.parse(JSON.stringify(item.ref_no))
    doc.brand_model = JSON.parse(JSON.stringify(item.brand_model_reserved))
    this.setState({brId:item.backupcar_registration_id,showAdd:true})
  }

  renderRowData() {
    let {messages} = this.props
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={8}>{messages['Data not found']}</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index} onClick={this.onRowSelect.bind(this,item)}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>{item.ref_no}</td>
              <td className='text-center'>{item.brand_model_reserved}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.brand_model}</td>
              <td className='text-center'>{item.used_period}</td>
              <td className='text-center'>{item.used_duration}</td>
              <td className='text-left'>{item.remark}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{minWidth:'1500px',marginBottom:'10px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{width:'50px'}}>{messages['Number']}</th>
              <th className='text-center' style={{width:'100px'}}>{messages['Reference number']}/<br />{messages['Backup car registration']}</th>
              <th className='text-center' style={{width:'150px'}}>{messages['Backup car brand']}</th>
              <th className='text-center' style={{width:'110px'}}>{messages['Car registration repair']}</th>
              <th className='text-center' style={{width:'110px'}}>{messages['Brand']}-{messages['Model']} ({messages['Car repair']})</th>
              <th className='text-center' style={{width:'110px'}}>{messages['Date']}</th>
              <th className='text-center' style={{width:'70px'}}>{messages['Right']}</th>
              <th className='text-center' style={{width:'200px'}}>{messages['Remark']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  renderNewItemButton() {
    let {messages} = this.props
    return (
      <div>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus' />&nbsp;{messages['Add backup car']}</Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderAddModal() {
    let {showAdd,doc,isSave,validDoc,brId} = this.state
    let {messages} = this.props
    return(
			<div>
				<Modal show={showAdd} enforceFocus={false} onHide={this.onAddHide.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>{brId?messages['Edit backup car']:messages['Add backup car']}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form horizontal>
              <FormGroup validationState={validDoc.ref_no}>
                <Col componentClass={ControlLabel} sm={4}>
                  {messages['Reference number']}/{messages['Car registration']}
                </Col>
                <Col sm={7}>
                  <FormControl value={doc.ref_no} onChange={this.onDocChange.bind(this,'ref_no')} placeholder={messages['Reference number']+'/'+messages['Car registration']} />
                </Col>
              </FormGroup>
              <FormGroup validationState={validDoc.brand_model}>
                <Col componentClass={ControlLabel} sm={4}>
                  {messages['Brand']}-{messages['Model']}
                </Col>
                <Col sm={7}>
                  <FormControl value={doc.brand_model} onChange={this.onDocChange.bind(this,'brand_model')} placeholder={messages['Brand']+'-'+messages['Model']} />
                </Col>
              </FormGroup>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className='pull-right'>
              <Button disabled={isSave?false:true} onClick={this.onSaveClick.bind(this)} bsStyle='primary'><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
              <Button onClick={this.onAddHide.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
            </div>
          </Modal.Footer>
        </Modal>
			</div>
		)
  }

  renderDateInput() {
    return(
      <DatePicker
        showFooter={true}
        popPlacement='bottom'
        value={this.state.date} 
        onChange={this.onDateChange.bind(this)}
      />
    )
  }

  render() {
    let {loading} = this.state
    let {messages} = this.props
    return(
      <div>
        <Box loading={loading}>
          <Box.Header border={true}>
            <Box.Title>{messages['Backup car table']}</Box.Title>
          </Box.Header>
          <Box.Body>
            <Form inline style={{marginBottom:'10px'}}>
              <FormGroup>
                {messages['Daily car reservation information']}
              </FormGroup>
              {' '}
              <FormGroup style={{width:'200px'}}>
                {this.renderDateInput()}
              </FormGroup>
            </Form>
            <div>
              {this.renderTable()}
              {this.renderNewItemButton()}
            </div>
          </Box.Body>
        </Box>
        {this.renderAddModal()}
        <NotificationSystem ref="notificationSystem" />
      </div>
    )
  } 
}

BackupCarRegistration.defaultProps = {
  
}

export default connect(
  (state) => ({messages: state.message.view.backupcar.BackupCarRegistration}),null,null,{withRef:true}
)(BackupCarRegistration);


// WEBPACK FOOTER //
// ./src/view/backupcar/BackupCarRegistration.js